import { render, staticRenderFns } from "./merklisteSection.vue?vue&type=template&id=8c7d029e&scoped=true&"
import script from "./merklisteSection.vue?vue&type=script&lang=js&"
export * from "./merklisteSection.vue?vue&type=script&lang=js&"
import style0 from "./merklisteSection.vue?vue&type=style&index=0&id=8c7d029e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7d029e",
  null
  
)

export default component.exports